module.exports = {"450406100":"龙圩镇","450406101":"大坡镇","450406102":"广平镇","450406103":"新地镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450406.json
// module id = 1937
// module chunks = 0